<template>
  <a-drawer placement="right" :closable="false" :mask-closable="false" :visible="drawer.visible" width="900" :body-style="{'padding':'10px 24px','box-sizing':'border-box','height':'92%','overflow':'auto'}">
    <div slot="title" class="gpws-drawer-title-span">
      <div class="gpws-drawer-close" @click="()=>onDrawerClose()"><a-icon type="close" style="margin-right: 3px" />关闭</div>
      <span class="gpws-drawer-title">远程审方</span>
      <span></span>
    </div>
    <a-spin :spinning="drawer.loading" tip="正在进行审方信息保存,请稍候...">
      <a-card size="small" :bordered="false" :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}" :body-style="{'padding':'0px'}">
      <span slot="title" class="gpws-model-title">
        <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>患者信息
      </span>
        <a-row>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="姓名" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.name }}
            </a-form-item>
          </a-col>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="年龄" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.age }}
            </a-form-item>
          </a-col>
          <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
            <a-form-item label="身份证号" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
              {{ drawer.record.idcard }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="性别" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.sexName }}
            </a-form-item>
          </a-col>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="孕否" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.gestate?'孕':'否' }}
            </a-form-item>
          </a-col>
          <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
            <a-form-item label="电话号码" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
              {{ drawer.record.phone }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="婚否" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.marriageName }}
            </a-form-item>
          </a-col>
          <a-col :xxl="17" :xl="17" :lg="17" :md="24" :sm="24" :xs="24">
            <a-form-item label="详细地址" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
              {{ drawer.record.address }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="就诊机构" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.organ }}
            </a-form-item>
          </a-col>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="就诊科室" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.department }}
            </a-form-item>
          </a-col>
          <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
            <a-form-item label="接诊医生" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.doctor }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(undefined != drawer.record.expert && null != drawer.record.expert && '' != drawer.record.expert)">
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="辅诊机构" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.expertOrgan }}
            </a-form-item>
          </a-col>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="辅诊科室" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.expertDepart }}
            </a-form-item>
          </a-col>
          <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
            <a-form-item label="辅诊专家" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.expert }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
            <a-form-item label="就诊类型" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
              {{ drawer.record.visitType }}
            </a-form-item>
          </a-col>
          <a-col :xxl="17" :xl="17" :lg="17" :md="24" :sm="24" :xs="24">
            <a-form-item :label="((drawer.record.status=='NEW' || drawer.record.status=='TREATING')?'初步诊断':'疾病诊断')" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
              {{ drawer.record.diagnostic }}
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <a-collapse :active-key="'c-1'" :default-active-key="'c-1'" :bordered="false" :accordion="true" expand-icon-position="right" style="margin-top: 10px;background:#fff;overflow-y: auto;">
        <a-collapse-panel v-for="(item, index) in drawer.record.recipes" :key="'c-'+(index+1)" style="background: #ffffff;">
          <span slot="header">
            <a-row>
              <a-col span="16" class="gpws-model-title">
                <img src="../../../assets/img/split.png" style="margin-left:8px;margin-right: 9px;user-select: none;"/>{{ item.typeName }}
              </a-col>
              <a-col span="4" style="text-align: right;"><span style="color: #D02F2F;">{{ item.drugs.length }}</span> 项药品</a-col>
              <a-col span="4" style="text-align: right;">{{ ((item.type == 'CM' && item.doses > 0)? ('付数:'+item.doses+'付'):((item.type != 'CM' && item.days > 0)?('天数:'+item.days+'天'):'')) }}</a-col>
            </a-row>
          </span>
          <a-row v-if="item.type == 'CM'">
            <template v-for="(e, i) in item.drugs">
              <a-col span="8" :key="e.code" style="padding-left: 30px;line-height: 32px; height: 32px;">
                {{ e.name }} &nbsp;{{ e.dosage }} &nbsp; {{ e.unit }}
              </a-col>
            </template>
          </a-row>
          <a-row v-else>
            <template v-for="(e, i) in item.drugs">
              <a-col v-if="(i%2 == 0)" span="10" :key="e.code" style="padding-left: 40px;line-height: 32px; height: 32px;">
                {{ e.name }} &nbsp;&nbsp;{{ e.spec }} &nbsp;&nbsp;{{ e.form }} &nbsp;&nbsp; {{ e.dosage }} &nbsp;{{ e.unit }}&nbsp;/&nbsp;{{e.frequency}} &nbsp;&nbsp; {{ e.salesQty }} &nbsp;{{ e.salesUnit }}
              </a-col>
              <a-col v-else span="14" :key="e.code" style="line-height: 32px; height: 32px;">
                {{ e.name }} &nbsp;&nbsp;{{ e.spec }} &nbsp;&nbsp;{{ e.form }} &nbsp;&nbsp; {{ e.dosage }} &nbsp;{{ e.unit }}&nbsp;/&nbsp;{{e.frequency}}&nbsp;&nbsp; {{ e.salesQty }} &nbsp;{{ e.salesUnit }}
              </a-col>
            </template>
          </a-row>
          <a-row>
            <a-col style="padding-left: 40px;line-height: 32px; height: 32px;">
              {{ item.usage }}
            </a-col>
          </a-row>
          <a-row>
            <a-col style="padding-left: 40px;line-height: 32px; height: 32px;">
              {{ item.advice }}
            </a-col>
          </a-row>
        </a-collapse-panel>
      </a-collapse>
      <a-card size="small" :bordered="false" :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}" :body-style="{'padding':'0px'}">
      <span slot="title" class="gpws-model-title">
        <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>远程审方
      </span>
        <a-form :form="drawer.form" layout="horizontal">
          <a-row>
            <a-col>
              <a-form-item :colon="false" label="审方结果" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <a-radio-group v-model="drawer.adopted">
                  <a-radio value="true">通过</a-radio>
                  <a-radio value="false">不通过</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-form-item :colon="false" label="审方说明" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <a-textarea v-model="drawer.explain"></a-textarea>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="margin-top: 20px;margin-bottom: 20px;background: #F3F3F3;border-radius: 4px;">
            <a-col offset="19" span="5">
              <a-form-item style="text-align: center;margin-bottom: 2px;">
                <img src="../../../assets/img/examine.png" style="cursor: pointer;user-select: none;margin-right: 24px;" @click="()=>examineAction()"/>
                <img src="../../../assets/img/close.png" style="cursor: pointer;user-select: none;" @click="()=>onDrawerClose()"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-card>
      <a-card v-if="drawer.record.existed" size="small"  :bordered="false" :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}" :body-style="{'padding':'0px'}">
      <span slot="title" class="gpws-model-title">
        <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>病历信息
      </span>
        <a-row v-if="(drawer.record.medical.complaint||'') != ''">
          <a-col>
            <a-form-item label="主诉" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.complaint }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.currHistory||'') != ''">
          <a-col>
            <a-form-item label="现病史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.currHistory }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.allergyHistory||'') != ''">
          <a-col>
            <a-form-item label="过敏史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.allergyHistory }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.auxiliary||'') != ''">
          <a-col>
            <a-form-item label="辅助检查" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.auxiliary }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.laboratory||'') != ''">
          <a-col>
            <a-form-item label="临床检验" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.laboratory }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="体格检查" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-row>
                <a-col v-if="drawer.record.medical.physical.height" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="身高" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.height }} CM
                  </a-form-item>
                </a-col>
                <a-col v-if="drawer.record.medical.physical.weight" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="体重" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.weight }} KG
                  </a-form-item>
                </a-col>
                <a-col v-if="drawer.record.medical.physical.pulse" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="脉搏" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.pulse }} 次/分钟
                  </a-form-item>
                </a-col>
                <a-col v-if="drawer.record.medical.physical.hr" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="心率" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.hr }} 次/分钟
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col v-if="drawer.record.medical.physical.temperature" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="体温" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.temperature }} ℃
                  </a-form-item>
                </a-col>
                <a-col v-if="drawer.record.medical.physical.sbp || drawer.record.medical.physical.dbp" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="血压" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.sbp }}/{{drawer.record.medical.physical.dbp }}mmHg
                  </a-form-item>
                </a-col>
                <a-col v-if="drawer.record.medical.physical.glu" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="血糖" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.glu }} mmol/L
                  </a-form-item>
                </a-col>
                <a-col v-if="drawer.record.medical.physical.breath" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                  <a-form-item label="呼吸" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                    {{drawer.record.medical.physical.breath }} 次/分钟
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.pastHistory||'') != ''">
          <a-col>
            <a-form-item label="既往史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.pastHistory }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.selfHistory||'') != ''">
          <a-col>
            <a-form-item label="个人史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.selfHistory }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.familyHistory||'') != ''">
          <a-col>
            <a-form-item label="家族史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.familyHistory }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.otherHistory||'') != ''">
          <a-col>
            <a-form-item label="其它病史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.otherHistory }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.record.medical.symptom||'') != ''">
          <a-col>
            <a-form-item label="望闻问切" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              {{ drawer.record.medical.symptom }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.pics||[]).length > 0">
          <a-col>
            <a-form-item label="症状图片" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <img v-for="(item, index) in (drawer.pics||[])" :src="item.url" :key="'img-'+(index+1)" class="img" @click="showFullImg(item.url)">
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.annexes||[]).filter(m => m.type == 'CHECK_RESULT').length > 0">
          <a-col>
            <a-form-item label="检查结果" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <img v-for="(item, index) in (drawer.annexes||[]).filter(m => m.type == 'CHECK_RESULT')" :src="item.pic.url" :key="'c-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.annexes||[]).filter(m => m.type == 'INSPECT_RESULT').length > 0">
          <a-col>
            <a-form-item label="检验结果" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <img v-for="(item, index) in (drawer.annexes||[]).filter(m => m.type == 'INSPECT_RESULT')" :src="item.pic.url" :key="'i-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.annexes||[]).filter(m => m.type == 'MEDICAL').length > 0">
          <a-col>
            <a-form-item label="病历资料" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <img v-for="(item, index) in (drawer.annexes||[]).filter(m => m.type == 'MEDICAL')" :src="item.pic.url" :key="'m-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="(drawer.annexes||[]).filter(m => m.type == 'PHYSICAL').length > 0">
          <a-col>
            <a-form-item label="体检报告" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <img v-for="(item, index) in (drawer.annexes||[]).filter(m => m.type == 'PHYSICAL')" :src="item.pic.url" :key="'p-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
    </a-spin>
  </a-drawer>
</template>

<script>
import Vue from 'vue';
import hevueImgPreview from 'hevue-img-preview';
Vue.use(hevueImgPreview);
export default {
  name: "ExamineDrawer",
  data(){
    return {
      current:{},
      drawer:{
        visible:false,
        loading:false,
        adopted:'true',
        explain:'',
        record:{},
        annexes:[],
        pics:[],
        form: this.$form.createForm(this)
      }
    }
  },
  methods:{
    showExamineAction:function (id){
      this.current = JSON.parse(localStorage.getItem("curruser"));
      const self = this;
      this.$axios.get('/api/clinic/outpatient/' + id+'/medical').then(function (res) {
        if (res.msg.flag == 0) {
          if(undefined != res.biz && null != res.biz){
            self.drawer.record = res.biz;
            self.drawer.annexes = res.biz.annexes||[];
            self.drawer.pics = res.biz.pics||[];
            self.drawer.visible = true;
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
      });
    },
    examineAction:function (){
      const self = this;
      this.drawer.loading = true;
      let params={id:this.drawer.record.id, adopted:this.drawer.adopted, explain:this.drawer.explain};
      this.$axios.post('/api/clinic/recipe/'+this.current.organId+'/'+this.current.doctorId+'/examine', params).then(function(res){
        self.drawer.loading = false;
        if(res.msg.flag == 0){
          self.$emit('clickit');
          self.onDrawerClose();
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(res){
      });
    },
    onDrawerClose:function (){
      this.drawer.record= {};
      this.drawer.visible = false;
    },
    showFullImg:function(url){
      this.$hevueImgPreview({
        url: url,
        mainBackground: 'rgba(0, 0, 0, .5)', // 整体背景颜色
        zIndex:99999
      });
    }
  }
}
</script>

<style scoped>
.gpws-m-b-2{
  margin-bottom: 2px!important;
}
.gpws-m-b-0{
  margin-bottom: 0px!important;
}
.img{
  width: 72px;
  height: 72px;
  border-radius:5px;
  border:#1890ff solid 1px;
  margin: 10px;
  cursor: pointer;
}
</style>